import { Component } from "../component"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export class BlogQuote extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      blogQuote: ".blog-quote",
    }
  }

  animateElements() {
    const { blogQuote } = this.$ui

    gsap.fromTo(
      blogQuote.children,
      {
        y: 50,
      },
      {
        y: 0,
        duration: 1.5,
        stagger: 0.1,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: blogQuote,
          start: "top center",
        },
      }
    )
  }

  created() {
    this.animateElements()
  }
}
